import { styled } from "theme/default/styled";
import { setFlexDFJCC } from "theme/setter/setFlexValues/setFlexDFJCC";

export const SHeaderCellDraggableContainer = styled.div`
  position: relative;
  width: 1px;

  ${setFlexDFJCC};
`;
